angular.module 'zc.masterApi'

.factory "MasterCampaign", ($resource, Api, $q, campaignServiceResponseTransformer) ->

  MasterCampaign = $resource Api.path("/api/master/campaigns/:campaignId"), { scope: @scope },
    get:
      campaignId: '@id'
    query:
      method: 'GET'
      transformResponse: campaignServiceResponseTransformer
      isArray: false # Rails returns object instead of array

  service =
    all: (params) ->
      d = $q.defer()
      MasterCampaign.query(params).$promise.then (res) ->
        d.resolve res.campaigns
      , (err) ->
        d.reject err
      d.promise

    get: (params) ->
      d = $q.defer()
      MasterCampaign.get(params).$promise.then (res) ->
        campaign = res.campaign
        campaign.public_api_json = res.public_api_json

        # replace nulls with string for easier hyouji
        for query in campaign.public_api_json
          delete query.segment
          delete query.raw
          for k,v of query
            if v == null
              query[k] = "null"

        d.resolve campaign
      , (err) ->
        d.reject err
      d.promise

    search: (options) ->
      $q (resolve, reject) ->
        Api.get "/api/master/campaigns/search", options
        .then (res) ->
          if !res.data.success
            reject null
          else
            resolve res.data.campaigns
        , (err) ->
          reject err


  service



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/api/master_campaign.service.coffee